"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  skeleton: function skeleton(props) {
    return {
      width: props.width,
      height: props.height,
      backgroundColor: "#00000009",
      position: "relative",
      display: "block",
      overflow: "hidden",
      borderRadius: props.variant === "circle" ? "50%" : props !== null && props !== void 0 && props.radius ? props.radius + 'px' : props.rounded ? "10px" : "0px",
      '&:after': {
        background: props.animation === "pulse" ? "#00000013" : props.animation === "wave" && "linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.09), transparent)",
        animation: props.animation === "pulse" ? "$pulseKeyframe 1.6s linear 0.5s infinite" : props.animation === "wave" && "$waveKeyframe 1.7s ease-in-out 0.5s infinite",
        content: '""',
        position: "absolute",
        transform: props.animation === "wave" && "translateX(100%)",

        /* Avoid flash during server-side hydration */
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
      }
    };
  },
  '@keyframes waveKeyframe': {
    "0%": {
      transform: "translateX(100%)"
    },
    "50%": {
      /* +0.5s of delay between each loop */
      transform: "translateX(100%)"
    },
    "100%": {
      transform: "translateX(-100%)"
    }
  },
  '@keyframes pulseKeyframe': {
    "0%": {
      opacity: 1
    },
    "50%": {
      opacity: 0.4
    },
    "100%": {
      opacity: 1
    }
  }
}), {
  name: 'pds-skeleton'
});
exports.useStyles = useStyles;